import { Component, EventEmitter, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { HttpService } from 'src/app/helpers/services/http.service';

@Component({
  selector: 'app-confirm',
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.css']
})
export class ConfirmComponent {

  public title: string = 'Confirm Action';
  public message: string = 'Are you sure you want to proceed?';
  public confirmText: string = 'Sure';
  public cancelText: string = 'Cancel';
  public loadingKey: string = '';

  @Output() confirmAction = new EventEmitter<void>();

  constructor(public activeModal: NgbActiveModal, public httpService: HttpService) { }

  onCancel() {
    this.activeModal.close(false);
  }

  onConfirm() {
    if (this.loadingKey) {
      this.confirmAction.emit();
    } else {
      this.activeModal.close(true);
    }
  }
}
